exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".comments{margin-top:20px}.comments .report{background-color:#ffffe0}.comments small{margin-right:10px}.comments .comment{margin:40px 0 20px;border-bottom:1px dashed #ccc;padding-bottom:5px}.comments .comment-properties{font-size:12px;font-weight:600;margin-top:15px}.comments .admin-comments textarea.form-control{padding:5px 10px}.comments .admin-comment-date{font-size:10px;text-align:right}.comments .admin-comment-cloud{background-color:#eee;padding:4px 8px 10px;border-radius:7px;margin-bottom:4px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/dashboard/comments/comments.scss
// module id = 598
// module chunks = 0